module.exports = __webpack_public_path__ + "img/icon-2.718ee974.png";